var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSail0)",
    d: "M16.286 17.306c-4.937-6.146-3.429-10.492-2.057-11.897c-3.703 3.373-2.4 8.674-1.286 10.903c1.028.595 2.657.908 3.343.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSail1)",
    d: "M7.543 14.332c.206-4.363 4.543-9.086 6.686-10.903c-4.32 5.55-3 10.735-1.8 12.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSail2)",
    d: "M6 17.057v-1.243s.257-.492 1.029-.492c1.971 0 7.877 2.708 9.771 2.725c1.093.009 1.714-.793 2.057-1.238c-.343.66-1.354 2.057-3 2.057c-2.057 0-5.841-2.306-8.828-2.306c-.618 0-.943.33-1.029.497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSail3)",
    d: "M7.174 16.783c-1.028 0-1.003 1.204-.745 1.671c0-.235.214-.835.745-.835c.755-.005 5.675 1.05 8.255 1.667C13.07 18.45 9 16.783 7.174 16.783"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSail0",
    x1: 12.425,
    x2: 12.425,
    y1: 3.434,
    y2: 19.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FED087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSail1",
    x1: 18.363,
    x2: 14.537,
    y1: 3.741,
    y2: 19.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00116A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#003180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0094C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CBEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSail2",
    x1: 5.743,
    x2: 18.899,
    y1: 6.746,
    y2: 6.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#00B1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#001169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSail3",
    x1: 6.249,
    x2: 14.773,
    y1: 17.644,
    y2: 20.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#00B1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#001169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011D6D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSail);
export default __webpack_public_path__ + "static/media/sail.70c9538416cf9d50ded105845723b2dd.svg";
export { ForwardRef as ReactComponent };